import Vue from 'vue';
import {
    GET_LISTING_STATUS,
    SET_LISTING_STATUS,
    GET_LISTING,
    SET_LISTING,
    GET_MARKET_REPORT,
    SET_MARKET_REPORT,
    SET_TOTAL_PAGE,
    ADD_SOLD_PICTURE
} from './constants';
import { checkSoldHousePreview } from '@/common/utils';
import { getListingStatus, getSnapshotListing, getMarketReport } from '../api';
export default {
    //  Obtained from the backend interface  listing status  and assign 
    async [GET_LISTING_STATUS]({ commit }, payload = {}) {
        let ret = await getListingStatus(payload.data);
        commit({
            type: SET_LISTING_STATUS,
            data: ret.data
        });
    },
    //  Obtained from the backend interface  listing  and assign 
    async [GET_LISTING]({ commit, dispatch }, payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        let ret = await getSnapshotListing(params);
        if (ret.listings) {
            commit({
                type: SET_LISTING,
                data: ret.listings
            });
            //  set pagination 
            commit({
                type: SET_TOTAL_PAGE,
                data: ret.totalPage
            });
            //  Complementary map 
            dispatch(ADD_SOLD_PICTURE);
        } else {
            console.log('get snapshot listing error');
        }
    },
    //  from   Get the backend interface  market report  and assign 
    async [GET_MARKET_REPORT]({ commit }, payload = {}) {
        const params = payload.data || {};
        params.listingSource && delete params.listingSource;
        params.listingType = 'sold-listing'; //  Write to death 
        let ret = await getMarketReport(params);
        commit({
            type: SET_MARKET_REPORT,
            data: ret.data && ret.data.marketReport
        });
    },
    // add picture
    async [ADD_SOLD_PICTURE]({ state }) {
        const { listing } = state;
        checkSoldHousePreview({ listings: listing }, Vue.set);
    }
};
